export default __webpack_public_path__ + "static/media/welkr.2002c626.svg";